var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 6094.6,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#F1F7FF",
    d: "m106.09994,4511.19988c0,27.7 23,50.6 50.6,50.6c27.7,0 50.6,-23 50.6,-50.6c0,-27.7 -23,-50.6 -50.6,-50.6c-28.3,0 -50.6,22.3 -50.6,50.6z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#F1F7FF",
    d: "m398.09994,4590.59988c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4c-43.4,0 -79.4,34.9 -79.4,79.4c0,43.4 36,79.4 79.4,79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#F1F7FF",
    d: "m398.09994,4348.19988c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4c-43.4,0 -79.4,36 -79.4,79.4c0,43.4 36,79.4 79.4,79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#F1F7FF",
    d: "m156.79994,4348.19988c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4c-44.5,0 -79.4,36 -79.4,79.4c0,43.4 36,79.4 79.4,79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#F1F7FF",
    d: "m370.39994,4752.59988c0,15.1 12.5,27.7 27.7,27.7c15.1,0 27.7,-12.5 27.7,-27.7c0,-15.1 -12.5,-27.7 -27.7,-27.7c-15.1,0 -27.7,12.5 -27.7,27.7z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#F1F7FF",
    d: "m156.79994,4831.99988c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4c-44.5,0 -79.4,36 -79.4,79.4c0,43.4 36,79.4 79.4,79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#F1F7FF",
    d: "m398.09994,3220.89988c-43.4,0 -79.4,36 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c0,-43.5 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#F1F7FF",
    d: "m156.79994,3220.89988c-44.5,0 -79.4,36 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c-0.1,-43.5 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#F1F7FF",
    d: "m398.09994,2979.49988c-43.4,-1.1 -79.4,34.9 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_11",
    fill: "#F1F7FF",
    ry: 119.6,
    rx: 119.6,
    cy: 3887.64014,
    cx: 636.64657,
    className: "st0",
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -853.02 290.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    fill: "#F1F7FF",
    d: "m156.79994,3178.39988c65.3,0 119.5,-54.1 119.5,-119.4c0,-65.3 -54.2,-119.5 -119.5,-119.5c-66.9,-1.6 -119.5,52.6 -119.5,119.5c0,65.2 54.2,119.4 119.5,119.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    fill: "#F1F7FF",
    d: "m318.69994,3785.09988c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4c-43.4,0 -79.4,34.9 -79.4,79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    fill: "#F1F7FF",
    d: "m156.79994,3689.79988c-53.4,0 -95.3,41.8 -95.3,95.3c0,52.5 42.8,95.3 95.3,95.3c52.5,0 95.3,-42.8 95.3,-95.3s-42.8,-95.3 -95.3,-95.3zm0,158.8c-34.5,0 -63.6,-29.1 -63.6,-63.5c0,-35.6 27.9,-63.5 63.6,-63.5c34.4,0 63.5,29.1 63.5,63.5s-29.1,63.5 -63.5,63.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_15",
    fill: "#F1F7FF",
    r: 79.4,
    cy: 4026.39988,
    cx: 156.79994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_16",
    fill: "#F1F7FF",
    r: 79.4,
    cy: 3542.69988,
    cx: 156.79994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_17",
    fill: "#F1F7FF",
    r: 40.9,
    cy: 3542.69988,
    cx: 398.09994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_18",
    fill: "#F1F7FF",
    r: 47.4,
    cy: 641.19988,
    cx: 156.79994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_19",
    fill: "#F1F7FF",
    r: 79.4,
    cy: 641.19988,
    cx: 398.09994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_20",
    fill: "#F1F7FF",
    r: 79.4,
    cy: 398.79988,
    cx: 398.09994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_21",
    fill: "#F1F7FF",
    ry: 79.4,
    rx: 79.4,
    cy: 363.84387,
    cx: 2064.4062,
    className: "st0",
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -969.335 2166.8)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_22",
    fill: "#F1F7FF",
    ry: 119.6,
    rx: 119.6,
    cy: 1266.07185,
    cx: 2754.76902,
    className: "st0",
    transform: "matrix(0.0332776 -0.9994 0.9994 0.0332776 -958.997 3593.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_23",
    fill: "#F1F7FF",
    r: 79.4,
    cy: 882.49988,
    cx: 156.79994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_24",
    fill: "#F1F7FF",
    d: "m398.09994,61.09988c-52.5,0 -95.3,42.8 -95.3,95.3c0,52.6 42.8,95.3 95.3,95.3c52.6,0 95.3,-42.7 95.3,-95.3c0,-52.5 -42.8,-95.3 -95.3,-95.3zm0,158.8c-34.4,0 -63.5,-29.1 -63.5,-63.5c0,-34.4 29.1,-63.5 63.5,-63.5c34.5,0 63.6,29.1 63.6,63.5c0,34.4 -29.1,63.5 -63.6,63.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_25",
    fill: "#F1F7FF",
    ry: 107.8,
    rx: 107.8,
    cy: -111.26039,
    cx: 771.0035,
    className: "st0",
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -512.887 554.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_26",
    fill: "#F1F7FF",
    d: "m156.79994,2496.79988c-44.5,0 -79.4,34.9 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c-0.1,-43.4 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_27",
    fill: "#F1F7FF",
    d: "m398.09994,2655.59988c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4c-43.4,0 -79.4,34.9 -79.4,79.4c0,43.4 36,79.4 79.4,79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_28",
    fill: "#F1F7FF",
    r: 121.9,
    cy: 2333.79988,
    cx: 398.09994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_29",
    fill: "#F1F7FF",
    r: 47.4,
    cy: 2333.79988,
    cx: 156.79994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_30",
    fill: "#F1F7FF",
    d: "m398.09994,2722.29988c-52.5,0 -95.3,42.8 -95.3,95.3c0,52.6 42.8,95.3 95.3,95.3c52.6,0 95.3,-42.8 95.3,-95.3c0,-52.6 -42.8,-95.3 -95.3,-95.3zm0,158.7c-34.4,0 -63.5,-29 -63.5,-63.5c0,-34.4 29.1,-63.5 63.5,-63.5c34.5,0 63.6,29.1 63.6,63.5c0,34.5 -29.1,63.5 -63.6,63.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_31",
    fill: "#F1F7FF",
    r: 79.4,
    cy: 2817.49988,
    cx: 156.79994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_32",
    fill: "#F1F7FF",
    r: 79.4,
    cy: 1365.19988,
    cx: 398.09994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_33",
    fill: "#F1F7FF",
    d: "m156.79994,1269.89988c-52.6,0 -95.3,42.8 -95.3,95.3c0,52.5 42.8,95.3 95.3,95.3c52.5,0 95.3,-42.8 95.3,-95.3c-0.1,-52.5 -42.8,-95.3 -95.3,-95.3zm0,158.9c-34.5,0 -63.6,-29.1 -63.6,-63.5c0,-35.1 28.5,-63.6 63.6,-63.6c34.4,0 63.5,29.1 63.5,63.6c0,34.4 -29.1,63.5 -63.5,63.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_34",
    fill: "#F1F7FF",
    d: "m438.99994,1123.89988c0,-22.4 -18.5,-40.9 -40.9,-40.9c-22.4,-0.5 -40.9,18 -40.9,40.9c0,22.4 18.5,40.9 40.9,40.9c22.4,0 40.9,-18.6 40.9,-40.9z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_35",
    fill: "#F1F7FF",
    d: "m318.69994,2091.39988c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4c-43.4,0 -79.4,36 -79.4,79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_36",
    fill: "#F1F7FF",
    d: "m156.79994,1203.29988c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4c-44.5,-1.1 -79.4,34.9 -79.4,79.4c0,43.4 36,79.4 79.4,79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_37",
    fill: "#F1F7FF",
    r: 40.9,
    cy: 1849.99988,
    cx: 398.09994,
    className: "st0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_38",
    fill: "#F1F7FF",
    ry: 107.8,
    rx: 107.8,
    cy: 1582.33961,
    cx: 771.0035,
    className: "st0",
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -1161.03 683.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_39",
    fill: "#F1F7FF",
    d: "m156.79994,2011.99988c-44.5,0 -79.4,36 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c-0.1,-43.4 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_40",
    fill: "#F1F7FF",
    d: "m156.79994,1528.19988c-44.5,0 -79.4,34.9 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c-0.1,-43.4 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_41",
    fill: "#F1F7FF",
    d: "m398.09994,1528.19988c-43.4,0 -79.4,34.9 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_42",
    fill: "#F1F7FF",
    d: "m196.49994,5736.49988c0,-27.7 -23,-50.6 -50.6,-50.6c-28.4,0 -50.6,22.3 -50.6,50.6c0,27.7 23,50.6 50.6,50.6c27.6,0.1 50.6,-22.9 50.6,-50.6z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_43",
    fill: "#F1F7FF",
    d: "m387.19994,5657.09988c-43.4,0 -79.4,34.9 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_44",
    fill: "#F1F7FF",
    d: "m387.19994,5414.69988c-43.4,0 -79.4,36 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_45",
    fill: "#F1F7FF",
    d: "m145.79994,5414.69988c-44.5,0 -79.4,36 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_46",
    fill: "#F1F7FF",
    d: "m387.19994,5950.19988c-15.1,0 -27.7,12.5 -27.7,27.7c0,15.1 12.5,27.7 27.7,27.7c15.1,0 27.7,-12.5 27.7,-27.7c-0.1,-15.1 -12.6,-27.7 -27.7,-27.7z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_47",
    fill: "#F1F7FF",
    d: "m145.79994,5898.49988c-44.5,0 -79.4,36 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_48",
    fill: "#F1F7FF",
    ry: 119.6,
    rx: 119.6,
    cy: 5547.48865,
    cx: 2673.80948,
    className: "st0",
    transform: "matrix(0.0985388 -0.9951 0.9951 0.0985388 -5396.84 7365.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_49",
    fill: "#F1F7FF",
    d: "m387.19994,5089.79988c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4c-43.4,0 -79.4,34.9 -79.4,79.4c0,43.4 36,79.4 79.4,79.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_50",
    fill: "#F1F7FF",
    d: "m145.89994,4915.09988c-53.4,0 -95.3,41.9 -95.3,95.3c0,52.6 42.8,95.3 95.3,95.3c52.5,0 95.3,-42.8 95.3,-95.3c-0.1,-52.6 -42.8,-95.3 -95.3,-95.3zm0,158.8c-34.5,0 -63.6,-29.1 -63.6,-63.6c0,-35.6 27.9,-63.5 63.6,-63.5c34.4,0 63.5,29.1 63.5,63.5c0,34.5 -29.1,63.6 -63.5,63.6z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_51",
    fill: "#F1F7FF",
    d: "m145.79994,5172.29988c-44.5,0 -79.4,36 -79.4,79.4c0,43.4 36,79.4 79.4,79.4c43.4,0 79.4,-36 79.4,-79.4c0,-43.4 -36,-79.4 -79.4,-79.4z",
    className: "st0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.63c4282da81d9ba8a335c55adfb1e251.svg";
export { ForwardRef as ReactComponent };